console.log("credit_application.js loaded");

document.addEventListener("turbo:load", () => {
  const $ = window.jQuery;
  if (!$) {
    console.error("jQuery not found!");
    return;
  }

  console.log("jQuery check →", typeof $);

  function toggleCoApplicant() {
    const showCoApplicant = $("#credit_application_co_applicant_attributes__destroy_false").is(":checked");
    const $coFields = $("#co_applicant_fields");

    if (showCoApplicant) {
      $coFields.show();
      $coFields.find("input, select, textarea").prop("disabled", false);
    } else {
      $coFields.hide();
      $coFields.find("input, select, textarea").prop("disabled", true);
    }
  }

  toggleCoApplicant();

  $("#credit_application_co_applicant_attributes__destroy_false, #credit_application_co_applicant_attributes__destroy_true").on("change", toggleCoApplicant);

  // Link to add a new employer and residence
  $("#credit_application form .add_child").off("click").on("click", function (event) {
    const $self = $(this);
    const assoc = $self.data("association");
    const content = $self.siblings(".outer_container").first().html();
    const regexp = new RegExp("new_" + assoc, "g");
    const newId = parseInt((new Date().getTime()).toString().substring(4), 10);
    const cleanContent = content.replace(regexp, newId);
    const title = assoc.substr(0, assoc.length - 1);
    const fName = "Additional " + title + " information";

    const $el = $(
      `<fieldset><legend style="display: flex; justify-content: space-between; margin: 1rem 0;">${fName} <a class="fas fa-trash remove mt-1" href="#"></a></legend>${cleanContent}</fieldset>`
    );

    $el.find("a.remove").click(function (e) {
      $(this).closest("fieldset").remove();
      e.preventDefault();
    });

    $el.find('input[type="hidden"][name$="[order]"]').val(newId);
    $self.before($el);

    event.preventDefault();
    return false;
  });

  $("#credit-app-submit").prop("disabled", false);

  const $creditAppForm = $("form#credi-app-form");
  if ($creditAppForm.length && !$creditAppForm.data("submitGuardBound")) {
    $creditAppForm.data("submitGuardBound", true);

    const $captchaError = $("#credit-app-captcha-error");

    function captchaRequired() {
      return $creditAppForm.data("captchaRequired") === true || $creditAppForm.data("captchaRequired") === "true";
    }

    function recaptchaResponsePresent() {
      const textarea = document.querySelector('textarea[name="g-recaptcha-response"]');
      if (textarea && textarea.value.trim().length > 0) {
        return true;
      }
      if (typeof grecaptcha !== "undefined" && typeof grecaptcha.getResponse === "function") {
        return grecaptcha.getResponse().length > 0;
      }
      return false;
    }

    $creditAppForm.on("submit", function (event) {
      const $submit = $("#credit-app-submit");

      if ($submit.prop("disabled")) {
        event.preventDefault();
        return false;
      }

      $captchaError.hide();

      if (captchaRequired() && !recaptchaResponsePresent()) {
        event.preventDefault();
        $captchaError.show();
        return false;
      }

      $submit.prop("disabled", true);
    });
  }

  $("#credit_application_applicant_attributes_date_of_birth").change(function () {
    const value = $(this).val();
    $(this).val(value.replace(/^([\d]{2})([\d]{2})([\d]{4})$/, "$1/$2/$3"));
  });

  $(".datePicker").datepicker({
    dateFormat: "mm/dd/yy",
    duration: "fast",
    showAnim: "show",
    numberOfMonths: 1,
    showButtonPanel: true,
  });

  const $firstError = $("#credi-app-form .is-invalid").first();
  if ($firstError.length) {
    $("html, body").animate({ scrollTop: $firstError.offset().top - 80 }, 200);
  }
});